<template>
  <div class="row contact-container">
    <div
      v-for="(contact, index) in contacts"
      :key="index"
      class="col-md-6 contact-box mt-2"
    >
      <div
        class="text-white circle-icon d-flex justify-content-center align-items-center"
      >
        <em :class="contact.icon" />
      </div>
      <span class="contact-label mb-3">{{ contact.label }}</span>
      <div class="references-box">
        <div v-for="(ref, refIndex) in contact.references" :key="refIndex">
          <em class="phone-icon" :class="ref.icon" />
          <span>{{ ref.name }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FooterContact',
  props: {
    contacts: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style scoped lang="scss">
.contact-container {
  .contact-box {
    display: flex;
    width: 50%;
    flex-direction: column;
    align-items: center;
    margin-bottom: 20px;

    .contact-label {
      font: Regular 14px/17px Lato;
      letter-spacing: 0px;
      color: #3f5b60;
    }
    .references-box {
      em {
        color: #2db782;
        margin-right: 10px;
      }
      span {
        text-align: center;
        font: Regular 16px/19px Lato;
        letter-spacing: 0px;
        color: #414141;
      }
    }
  }

  .icon-box {
    em {
      color: #fff;
      margin-top: -5px;
      margin-left: -7px;
    }
  }
}

.circle-icon {
  display: inline-block;
  background: #3f5b60;
  width: 38px;
  height: 38px;
  border-radius: 50%;
  text-align: center;
  line-height: 3px;
  padding: 20px;
}

.icon-background {
  color: #3f5b60;
}
</style>
